import { GridOptions } from 'ag-grid-enterprise';

import { Dictionary } from '../cross-cutting/models';

export interface TsTableOptions {
  headerName?: string;
  field?: string;
  cellRendererParams?: any;
  sortable?: boolean;
  filter?: boolean;
  resizable?: boolean;
  checkboxSelection?: boolean;
  headerCheckboxSelection?: boolean;
  suppressMovable?: boolean;
  lockPosition?: 'left' | 'right';
  lockPinned?: boolean;
  editable?: boolean | ((params: any) => boolean);
  isNestedField?: boolean;
  cellRenderer?: any | ((params: any) => any);
  pinned?: 'left' | 'right';
  flex?: number;
  rowGroup?: boolean;
  rowDrag?: boolean;
  headerClass?: string;
  aggFunc?: any;
  suppressHeaderMenuButton?: boolean;
  enableValue?: boolean;
  hide?: boolean;
  width?: number;
  cellStyle?: any;
  autoHeight?: boolean;
  cellEditor?: any;
  maxWidth?: number;
  minWidth?: number;
  suppressAutoSize?: boolean;
  suppressSizeToFit?: boolean;
  cellClass?: string | string[] | ((params: any) => string | string[]);
  cellClassRules?: any;
  titleCase?: boolean;
  tooltipField?: string;
  wrapText?: boolean;
  onCellClicked?: (params: any) => void;
  tooltipValueGetter?: (params: any) => any;
  sort?: 'asc' | 'desc' | null;
  valueGetter?: (params: any) => any;
  valueFormatter?: (params: any) => any;
  cellRendererSelector?: (params: any) => any;
  cellEditorSelector?: (params: any) => any;
}

export interface ColumnDef {
  tsTableOptions?: TsTableOptions;
  label: string;
  name: string;
  groupLabel?: string;
  type?: FieldDefType | ((params: any) => FieldDefType);
  meta?: FieldDefMeta;
  _parentFieldName?: string;
  _parentFieldLabel?: string;
  related_to_type?: string;
  locked?: boolean;
}

export type FieldDefType =
  | 'number'
  | 'money'
  | 'text'
  | 'percent'
  | 'select'
  | 'checkbox'
  | 'date'
  | 'datetime'
  | 'decimal'
  | 'textarea'
  | 'record'
  | 'url'
  | 'typeahead'
  | 'tags'
  | 'year'
  | 'id';

export type FieldDefMeta = {
  option_name?: string;
  // exclude_in_nested_fields?: boolean;
  // related_to_type?: any;
  // calc_code?: string | null;
  // default_calc_code?: string;
  // calc_index?: number;
  // filtering?: {
  //   operators?: string[];
  //   values?: string[];
  //   functions?: any[];
  //   exclude_in_nested_filter?: boolean;
  // };
  // reporting?: {
  //   hidden?: boolean;
  // };
  // is_calculated?: boolean;
  // is_custom?: boolean;
  multi_select?: boolean;
  options?: any[];
  readonly?: boolean;
  record_type?: string;
  scale?: any;
  sorting?: string;
  // user_editable?: boolean;
  // // the following props do not come from the API, they are FE only
  // shapeShifter?: ColumnDef;
  // shapeShifted?: boolean;
  group?: any;
  groupable?: boolean;
  value_hidden?: boolean;
};

export type OptionsFilterFn = Dictionary<(options: any[], model: any) => any[]>;

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  autoSizeStrategy: {
    type: 'fitCellContents',
  },
};
